/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelid200,
  GetApiV1IndividualpaymentParcelsParcelid400,
  GetApiV1IndividualpaymentParcelsParcelid401,
  GetApiV1IndividualpaymentParcelsParcelid404,
  GetApiV1IndividualpaymentParcelsParcelid500,
  GetApiV1IndividualpaymentParcelsParcelidPathParams,
  GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelid.ts";
import { individualPaymentParcelDetailViewModelSchema } from "../individualPaymentParcelDetailViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidPathParams>;

export const getApiV1IndividualpaymentParcelsParcelidQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelid200Schema = z.lazy(
  () => individualPaymentParcelDetailViewModelSchema,
) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelid200>;

/**
 * @description Empresa do usuário não tem acesso a esta matrícula
 */
export const getApiV1IndividualpaymentParcelsParcelid400Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelid401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentParcelsParcelid404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelid500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelid500>;

export const getApiV1IndividualpaymentParcelsParcelidQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelid200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidQueryResponse>;
